import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback((toast) => {
    const id = ++idRef.current;
    const ttl = toast.ttl ?? 3500;
    const item = { id, title: toast.title, description: toast.description, variant: toast.variant || 'default' };
    setToasts((prev) => [item, ...prev].slice(0, 6));
    window.setTimeout(() => removeToast(id), ttl);
  }, [removeToast]);

  const value = useMemo(() => ({ addToast, removeToast }), [addToast, removeToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="fixed bottom-4 right-4 rtl:right-auto rtl:left-4 z-[9999] space-y-2 w-[92vw] max-w-sm">
        {toasts.map((t) => (
          <div key={t.id} className={`rounded-xl border p-3 shadow-md bg-card text-card-foreground ${t.variant === 'success' ? 'border-green-300' : t.variant === 'error' ? 'border-red-300' : 'border-border'}`}>
            {t.title && <div className="text-sm font-medium mb-0.5">{t.title}</div>}
            {t.description && <div className="text-xs text-muted-foreground">{t.description}</div>}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}


